// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3nCdR","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__300A8"};